@if (alert) {
    <main class="agpr-alert">
        <div class="agpr-alert-container">
            <section
                class="agpr-alert-content"
                [attr.aria-label]="'Common.layout.main' | localize"
            >
                <agpr-scroll-panel>
                    <div class="agpr-alert-builderContainer">
                        <h2
                            class="agpr-alert-name"
                            [ngClass]="{'agpr-alert-name--visible': alert.name}"
                        >
                            @if (alert.name) {
                                <span>{{ alert.name }}</span>
                            }
                            &nbsp;
                            <span class="u-srOnly">{{ 'Monitor.primaryHeading.coverageAlert' | localize }}</span>
                        </h2>

                        @if (sourceDeleted) {
                            <agpr-message [severity]="severity.error">
                                {{ 'Alerts.input.alertSource.sourceNotFound' | localize }}
                            </agpr-message>
                        }

                        <agpr-page-builder></agpr-page-builder>
                    </div>
                </agpr-scroll-panel>

                <div class="agpr-alert-bannerMessage">
                    @if (isShowBannerMessage) {
                        <agpr-message
                            [bannerIcon]="true"
                            tooltipPosition="top"
                            [toggleTooltip]="'Common.bannerMessage.toggleIconTooltip' | localize"
                            [severity]="severity.error"
                            [toggleable]="true"
                            [collapsed]="true"
                            [closeable]="true"
                            [showBannerMessage]="isShowBannerMessage"
                            [toggleableContent]="bannerMessage"
                            (collapsedChange)="isMessageExpanded($event)"
                            [icon]="isBannerExpanded ? 'fa-regular fa-duotone fa-minus-circle agpr-message-icon-bannerExpandedIcon' : null"
                            (dismiss)="isShowBannerMessage = false"
                            [noBottomCornerRadius]="true"
                            [style]="agprComponentStyleEnum.social"
                        >
                            <span>{{ 'Common.bannerMessage.messageInfo' | localize }}</span>
                            @if (isBannerExpanded) {
                                <span>{{ 'Common.bannerMessage.expendedMessageInfo' | localize}}</span>
                            }

                            <ng-template #bannerMessage>
                                @for (error of bannerErrorList; track error) {
                                    <agpr-button
                                        [style]="buttonTypes.link"
                                        (click)="focusErrorElement(error.errorId)"
                                        [attr.aria-label]="error.label | localize"
                                    >
                                        <span> {{ error.label | localize }} </span>
                                    </agpr-button>
                                }
                            </ng-template>
                        </agpr-message>
                    }
                </div>

                <!-- @if (precisionClipProcess && precisionClipProcess.status === 'pending') {
                    <div class="agpr-alert-bannerMessage">
                        <agpr-message
                            [severity]="severity.info"
                            [autoFit]="true"
                            [showBannerMessage]="true"
                        >
                            <div class="agpr-alert-bannerMessage-row">
                                <span> {{
                                    'Briefings.blockType.precisionClip.progress' | localize: {
                                        count: precisionClipProcess.clipsCompleted || 0,
                                        totalInsightsToComplete: precisionClipProcess.totalClipsToComplete || 0
                                    }
                                    }}
                                </span>
                                <agpr-button
                                    [id]="id + '_precisionClipBanner_cancelButton'"
                                    class="agpr-alert-link"
                                    [style]="buttonTypes.link"
                                    label="Monitoring.cancel"
                                    (click)="cancelPrecision()"
                                ></agpr-button>
                            </div>
                        </agpr-message>
                    </div>
                } -->


                <agpr-action-bar [headingContext]="'Alerts.alert' | localize">
                    <ng-template #right>
                        @if (alert.status === briefingStatus.DRAFT && isDirty || !alert.id) {
                            <agpr-button
                                [id]="id + '_saveAsDraft'"
                                label="saveAsDraft"
                                [style]="buttonTypes.primary"
                                [disabled]="disableSaveButton"
                                (click)="saveDraft()"
                            ></agpr-button>
                        }

                        @if (isDirty && alert.status !== briefingStatus.DRAFT) {
                            <agpr-button
                                [id]="id + '_update'"
                                label="update"
                                [style]="buttonTypes.primary"
                                [disabled]="disableSaveButton"
                                (click)="update()"
                            ></agpr-button>
                        }

                        @if (alert.status === briefingStatus.SCHEDULED || alert.status === briefingStatus.ACTIVE) {
                            <agpr-button
                                [id]="id + '_pause'"
                                label="pause"
                                [style]="buttonTypes.primary"
                                (click)="pause()"
                            ></agpr-button>
                        }

                        @if (!isDirty && alert.status === briefingStatus.EXPIRED) {
                            <agpr-button
                                [id]="id + '_renew'"
                                label="Alerts.renew"
                                [style]="buttonTypes.primary"
                                (click)="renew()"
                            ></agpr-button>
                        }

                        @if (alert.status === briefingStatus.PAUSED ||
                            (alert.status === briefingStatus.DRAFT && !isDirty && alert.id)
                        ) {
                            <agpr-button
                                [id]="id + '_activate'"
                                label="activate"
                                [style]="buttonTypes.primary"
                                [disabled]="sourceDeleted"
                                [tooltip]="sourceDeleted ? 'Alerts.input.alertSource.sourceNotFound' : ''"
                                (click)="activate()"
                            ></agpr-button>
                        }
                    </ng-template>
                </agpr-action-bar>
            </section>

            <aside
                class="agpr-alert-sidebar"
                [attr.aria-label]="'Common.layout.rhp' | localize"
            >
                <agpr-right-sidebar
                    #rhp
                    [(selectedTabIndex)]="selectedTabIndex"
                >
                    <!-- we want to always show the mention source selector -->
                    <agpr-tab
                        [id]="id + '_ComponentList'"
                        icon=" fa-list-ul"
                        tooltip="Alerts.rhp.setup"
                    >
                        <agpr-panel header="Alerts.sidebar.headingTopic">
                            <agpr-monitoring-source-picker-without-facet-field
                                #sourcePicker
                                [id]="id + '_sourcePickerField'"
                                [value]="selectedSource"
                                [field]="sourcePickerFieldModel"
                                (changes)="sourceSelected($event)"
                                (sourceNotFound)="handleSourceNotFound($event)"
                                [ariaInvalid]="fieldErrors.noSource"
                                ariaDescribedBy="source_error"
                                [showHiddenOption]="true"
                            ></agpr-monitoring-source-picker-without-facet-field>

                            @if (showErrorsLevel >= sendErrors && fieldErrors.noSource) {
                                <agpr-form-message
                                    #sidebarError
                                    id="source_error"
                                >
                                    {{ 'Alerts.input.alertTopic.validation' | localize }}
                                </agpr-form-message>
                            }

                            @if (showErrorsLevel >= draftErrors && fieldErrors.invalidFilter) {
                                <agpr-form-message
                                    #sidebarError
                                    id="invalid_filter"
                                >
                                    {{ filterError | localize }}
                                </agpr-form-message>
                            }
                        </agpr-panel>

                        @if (alert.alertType === alertTypes.SURGE) {
                            <agpr-panel
                                header="Briefings.blockType.alertSurge.metric"
                                [marginTop]="0"
                            >
                                <div class="agpr-formField agpr-alert-surge">
                                    <agpr-dropdown
                                        label="Alerts.surge.metric.selectMetric"
                                        [id]="id + '_surge_selectMetric'"
                                        [(ngModel)]="metric"
                                        (ngModelChange)="metricChanged()"
                                        [options]="metricTypesOptions"
                                        [bindToValue]="true"
                                    ></agpr-dropdown>
                                    <div class="agpr-alert-surge-sensitivity">
                                        <div>
                                            {{ 'Alerts.surge.metric.sensitivity' | localize }}
                                            <span
                                                role="img"
                                                class="agpr-alert-surge-sensitivity-tooltip fa-regular fa-circle-info"
                                                agprTooltip="{{ 'Alerts.surge.metric.sensitivity.tooltip' | localize:{ 'metric': 'Alerts.surge.metrics.' + metric } }}"
                                            ></span>
                                        </div>
                                        <agpr-number-input
                                            [id]="id + '_surge_sensitivity'"
                                            [(ngModel)]="sensitivity"
                                            (ngModelChange)="sensitivityChanged()"
                                            [integerOnly]="true"
                                            [bottomMargin]="false"
                                            [min]="1"
                                            [max]="10000"
                                        ></agpr-number-input>
                                        <div class="agpr-alert-surge-sensitivity-percentage">%</div>
                                    </div>

                                    <div class="agpr-formField agpr-alert-surge-sensitivity-link">
                                        <agpr-button
                                            [id]="id + '_surge_showSensitivityDialog'"
                                            (click)="showSensitivityPanel()"
                                            [style]="buttonTypes.link"
                                            ariaHasPopup="dialog"
                                            [disabled]="!sourceLoaded"
                                            [ariaControls]="'alerts_surge_showSensitivityDialog'"
                                            [tooltip]="'Alerts.surge.sensitivity.dialog.tooltip'"
                                        >
                                            {{ 'Alerts.surge.metric.sensitivity.dialog.button' | localize }}
                                            <span class="fa-solid fa-window-restore agpr-alert-surge-sensitivity-link-dialogIcon"></span>
                                        </agpr-button>
                                    </div>
                                </div>
                            </agpr-panel>

                            <agpr-panel
                                header="Briefings.blockType.alertSurge.coolDownPeriod"
                                [tooltip]="'Alerts.surge.cooldown.tooltip'"
                                [marginTop]="0"
                            >
                                <div class="agpr-formField agpr-alert-surge-cooldown">
                                    <agpr-dropdown
                                        [id]="id + '_surge_selectCooldown'"
                                        [(ngModel)]="coolDownPeriod"
                                        (ngModelChange)="coolDownChanged()"
                                        [options]="cooldownTypesOptions"
                                        [bindToValue]="true"
                                    ></agpr-dropdown>
                                </div>
                            </agpr-panel>
                        }

                        <agpr-panel
                            header="Alerts.sidebar.headingDeliveryOptions"
                            [marginTop]="0"
                        >
                            <div class="agpr-alert-deliveryOptions-checkbox">
                                <!-- Email delivery option -->
                                <agpr-checkbox
                                    [id]="id + '_deliveryOptions_email'"
                                    label="Alerts.deliveryOptions.email"
                                    [(ngModel)]="alert.selectedDeliveryOption.email"
                                    [binary]="true"
                                    (onChange)="deliveryOptionChanged($event, deliveryOptionsEnum.email)"
                                    ariaDescribedBy="deliveryOption_error"
                                ></agpr-checkbox>
                            </div>

                            @if (alert?.selectedDeliveryOption.email) {
                                <div class="agpr-alert-deliveryOptions">
                                    @if (alert.alertType !== alertTypes.SURGE) {
                                        <agpr-text-input
                                            [id]="id + '_subjectLineTextInput'"
                                            [placeholder]="'Alerts.input.subjectLine.placeholder' | localize"
                                            [label]="'Alerts.input.subjectLine'"
                                            [maxLength]="maxInputTextLength"
                                            [(ngModel)]="alert.subject"
                                            (ngModelChange)="subjectChanged($event)"
                                            (blur)="fieldErrors.subjectLength = false"
                                            [ariaInvalid]="fieldErrors.subjectEmpty"
                                            ariaDescribedBy="subject_errors"
                                        ></agpr-text-input>
                                        <ul id="subject_errors">
                                            <li>
                                                @if (showErrorsLevel >= sendErrors && fieldErrors.subjectEmpty) {
                                                    <agpr-form-message #sidebarError>
                                                        {{ 'Alerts.input.subjectLine.validation' | localize }}
                                                    </agpr-form-message>
                                                }
                                            </li>
                                            <li>
                                                @if (fieldErrors.subjectLength) {
                                                    <agpr-form-message #sidebarError>
                                                        {{ 'Alerts.error.maxLengthReached' | localize:{ 'length': maxInputTextLength} }}
                                                    </agpr-form-message>
                                                }
                                            </li>
                                        </ul>
                                    }

                                    <agpr-text-input
                                        [id]="id + '_fromNameTextInput'"
                                        [maxLength]="maxInputTextLength"
                                        [placeholder]="'Alerts.input.fromName.placeholder' | localize"
                                        [label]="'Alerts.input.fromName'"
                                        [(ngModel)]="alert.fromName"
                                        (ngModelChange)="fromNameChanged($event)"
                                        (blur)="fieldErrors.fromNameLength = false"
                                        [ariaInvalid]="fieldErrors.fromNameEmpty"
                                        ariaDescribedBy="fromName_errors"
                                    ></agpr-text-input>
                                    <ul id="fromName_errors">
                                        <li>
                                            @if (showErrorsLevel >= sendErrors && fieldErrors.fromNameEmpty) {
                                                <agpr-form-message #sidebarError>
                                                    {{ 'Alerts.input.fromName.validation' | localize }}
                                                </agpr-form-message>
                                            }
                                        </li>
                                        <li>
                                            @if (fieldErrors.fromNameLength) {
                                                <agpr-form-message #sidebarError>
                                                    {{ 'Alerts.error.maxLengthReached' | localize:{ 'length': maxInputTextLength} }}
                                                </agpr-form-message>
                                            }
                                        </li>
                                    </ul>

                                    <agpr-text-input
                                        [id]="id + '_replyToTextInput'"
                                        [maxLength]="maxInputTextLength"
                                        [placeholder]="'Alerts.input.replyTo.placeholder' | localize"
                                        [label]="'Alerts.input.replyTo'"
                                        [(ngModel)]="alert.replyTo"
                                        (ngModelChange)="replyToChanged($event)"
                                        (blur)="fieldErrors.replyToLength = false; checkReplyToFormat()"
                                        [ariaInvalid]="fieldErrors.replyToEmpty || fieldErrors.replyToInvalidFormat"
                                        ariaDescribedBy="replyTo_errors"
                                    ></agpr-text-input>
                                    <ul id="replyTo_errors">
                                        <li>
                                            @if (showErrorsLevel >= sendErrors && fieldErrors.replyToEmpty) {
                                                <agpr-form-message #sidebarError>
                                                    {{ 'Alerts.input.replyTo.validation' | localize }}
                                                </agpr-form-message>
                                            }
                                        </li>
                                        <li>
                                            @if (fieldErrors.replyToInvalidFormat) {
                                                <agpr-form-message #sidebarError>
                                                    {{ 'Alerts.error.validEmail' | localize }}
                                                </agpr-form-message>
                                            }
                                        </li>
                                        <li>
                                            @if (fieldErrors.replyToLength) {
                                                <agpr-form-message #sidebarError>
                                                    {{ 'Alerts.error.maxLengthReached' | localize:{ 'length': maxInputTextLength} }}
                                                </agpr-form-message>
                                            }
                                        </li>
                                    </ul>
                                    <div class="agpr-inputGroup">
                                        <agpr-email-chips
                                            [id]="id + '_recipientList'"
                                            [(value)]="alert.recipientList"
                                            (valueChange)="recipientsChanged($event)"
                                            [placeholder]="'Alerts.input.recipients.placeholder' | localize"
                                            [errorKey]="'Alerts.error.validEmail' | localize"
                                            header="Alerts.input.recipients"
                                            [ariaInvalid]="fieldErrors.recipientsEmpty"
                                            ariaDescribedBy="recipient_error"
                                        ></agpr-email-chips>
                                    </div>
                                    @if (showErrorsLevel >= sendErrors && fieldErrors.recipientsEmpty) {
                                        <agpr-form-message
                                            #sidebarError
                                            id="recipient_error"
                                        >
                                            {{ 'Alerts.input.recipients.validation' | localize }}
                                        </agpr-form-message>
                                    }
                                </div>
                            }

                            @if (alert.alertType === alertTypes.RECENT) {
                                <!-- RSS Feed Delivery Option -->
                                <div class="agpr-alert-deliveryOptions-checkbox">
                                    <agpr-checkbox
                                        [id]="id + '_deliveryOptions_rss'"
                                        label='Briefings.deliveryOptions.rssFeed'
                                        [(ngModel)]="alert.selectedDeliveryOption.rssFeed"
                                        [binary]="true"
                                        infoCircleTooltip="Alerts.deliveryOptions.rssFeed.tooltip"
                                        (onChange)="deliveryOptionChanged($event, deliveryOptionsEnum.rssFeed)"
                                        ariaDescribedBy="deliveryOption_error"
                                    ></agpr-checkbox>
                                </div>

                                @if (alert?.selectedDeliveryOption.rssFeed) {
                                    <div class="agpr-alert-deliveryOptions">
                                        <agpr-rss-feed-picker
                                            id="rssFeedPicker"
                                            [(ngModel)]="alert.feeds"
                                            (change)="rssFeedChanged($event)"
                                        ></agpr-rss-feed-picker>
                                    </div>
                                }
                            }

                            @if (showDeliveryOptionsErrorMsg) {
                                <agpr-form-message
                                    id="deliveryOption_error"
                                    class="agpr-alertError"
                                >
                                    {{ 'Briefings.deliveryOptions.validation' | localize }}
                                </agpr-form-message>
                            }
                        </agpr-panel>

                        <agpr-panel
                            header="Alerts.sidebar.headingScheduling"
                            [marginTop]="0"
                        >
                            <agpr-delivery-range-scheduler
                                [id]="id + '_deliveryRange'"
                                [(ngModel)]="timeRange"
                                (ngModelChange)="timeRangeChanged()"
                                [minEndDate]="minEndDate"
                                ariaDescribedBy="scheduling_errors"
                            ></agpr-delivery-range-scheduler>

                            <ul id="scheduling_errors">
                                <li>
                                    @if (showErrorsLevel >= sendErrors && fieldErrors.timeRangePast) {
                                        <agpr-form-message #sidebarError>
                                            {{ 'Alerts.input.timeRange.endDatePast' | localize }}
                                        </agpr-form-message>
                                    }
                                </li>
                                <li>
                                    @if (showErrorsLevel >= sendErrors && fieldErrors.endDateLessThanStartDate) {
                                        <agpr-form-message #sidebarError>
                                            {{ 'Alerts.input.timeRange.endDateLessThanStartDate' | localize }}
                                        </agpr-form-message>
                                    }
                                </li>
                                <li>
                                    @if (showErrorsLevel >= sendErrors && fieldErrors.timeRangeIncomplete) {
                                        <agpr-form-message #sidebarError>
                                            {{ 'Alerts.input.timeRange.incomplete' | localize }}
                                        </agpr-form-message>
                                    }
                                </li>
                            </ul>
                        </agpr-panel>
                    </agpr-tab>

                    <agpr-tab
                        [id]="id + '_componentblock_selection'"
                        icon="fa-kit-duotone fa-agpr-components"
                        tooltip="Alerts.sidebar.headingComponents"
                    >
                        <agpr-panel header="Alerts.sidebar.headingComponents">
                            <agpr-block-adder
                                [id]="id + '_blockAdder'"
                                [draggable]="true"
                            ></agpr-block-adder>
                        </agpr-panel>

                        <agpr-panel header="Briefings.sidebar.layouts">
                            <agpr-layout-block-adder
                                [id]="id + '_layoutBlockAdder'"
                                [draggable]="true"
                            ></agpr-layout-block-adder>
                        </agpr-panel>
                    </agpr-tab>

                    <agpr-tab
                        #blockFormTab
                        [id]="id + '_componentblock_edit'"
                        icon=" fa-wrench"
                        tooltip="Alerts.rhp.blockEdit"
                        [disabled]="!selectedBlock"
                    >
                        <agpr-block-form></agpr-block-form>
                        <ng-template #tabFooter>
                            <agpr-action-bar
                                [headingContext]="'Alerts.rhp.customize.footerContext' | localize"
                                [headingLevel]="4"
                            >
                                <ng-template #right>
                                    <agpr-button
                                        [id]="id + '_applyButton'"
                                        label="Alerts.apply"
                                        [style]="buttonTypes.tertiary"
                                        (click)="alertsService.confirmChangesToSelectedBlock()"
                                    ></agpr-button>
                                </ng-template>
                            </agpr-action-bar>
                        </ng-template>
                    </agpr-tab>

                    <agpr-tab
                        [id]="id + '_detailsTab'"
                        icon=" fa-file-lines"
                        tooltip="Alerts.sidebar.headingDetails"
                        [disabled]="!alert || !alert.id"
                    >
                        <div class="agpr-alert-sidebar-alertDetails">
                            <agpr-attribute-list
                                [attributes]="attributes"
                            >
                            </agpr-attribute-list>
                        </div>
                    </agpr-tab>

                    @if (alert.alertType === alertTypes.RECENT) {
                        <agpr-tab
                            [id]="id + '_component_customize'"
                            icon=" fa-paintbrush"
                            tooltip="Alerts.rhp.customize"
                        >
                            <agpr-alert-global-customization
                                [id]="id + '_customization'"
                            ></agpr-alert-global-customization>
                        </agpr-tab>
                    }
                </agpr-right-sidebar>
            </aside>
        </div>
    </main>
}

<ng-template let-feed #rssFeedDisclaimer>
    @if (feed) {
        <div class="agpr-alert-rssFeedDisclaimer">
            <span> {{ feed.name }} </span>
            <span class="fa fa-rss agpr-alert-rssFeedDisclaimer-icon" aria-hidden="true"></span>
            <a class="agpr-alert-rssFeedDisclaimer-link" [href]="feed.url" target="_blank"> {{ feed.url }} </a>
        </div>
    }
</ng-template>
